import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useState } from 'react';
import { addLogo } from 'redux/slices/organization';
import { RootState, useSelector } from 'redux/store';
import useCustomDispatch, { CustomDispachActionPromise } from 'redux/dispatch';
import CustomDropzone, { DropzoneFile, DropzoneStatus } from 'components/CustomDropzone';
import { useTranslator } from 'translation/useTranslator';
import { Button } from '@nps.today/component-library';

type AddLogoDialogProps = {
  display: boolean;
  hideModal: () => void;
  uploadLogo?: (file: any) => () => Promise<any | CustomDispachActionPromise>;
};
const AddLogoDialog = (props: AddLogoDialogProps) => {
  const translator = useTranslator();
  const customDispatch = useCustomDispatch();
  const [file, setFile] = useState<DropzoneFile | null>(null);
  const [isFileTooBig, setIsFileTooBig] = useState(false);
  const { isLogoLoading } = useSelector((state: RootState) => state.organization);
  const onValidateDropzone = (file: DropzoneFile | null) => {
    setFile(file);
    return true;
  };

  const onChangeStatusDropzone = (_: DropzoneFile, status: DropzoneStatus) => {
    if (status === 'removed') {
      onValidateDropzone(null);
    }
    setIsFileTooBig(status === 'error_file_size');
  };

  const onUploadLogo = async () => {
    customDispatch({
      action: props.uploadLogo ?? addLogo,
      actionParameters: file?.file,
      onSuccess: () => {
        setFile(null);
        props.hideModal();
      }
    });
  };

  return (
    <Dialog open={props.display} onClose={props.hideModal}>
      <DialogTitle>{translator.uploadNewLogo()}</DialogTitle>
      <DialogContent sx={{ width: '30rem' }}>
        <Box p={1}>
          <CustomDropzone
            inputContent={
              <Typography key="dropzoneInputContent">
                {translator.dragFilesOrClickToBrowse()}
              </Typography>
            }
            accept="image/*"
            onChangeStatus={onChangeStatusDropzone}
            validate={onValidateDropzone}
            maxFiles={1}
            maxSizeBytes={512000}
          />
          {isFileTooBig && (
            <Typography variant="caption" color="error">
              {translator.maxFileSizeIs('500')}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button dataTestId="add-logo-dialog-cancel" color="primary" onClick={props.hideModal}>
          {translator.cancel()}
        </Button>
        <Button
          dataTestId="add-logo-dialog-upload"
          disabled={!file}
          loading={isLogoLoading}
          color="primary"
          variant="contained"
          onClick={onUploadLogo}
        >
          {translator.upload()}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddLogoDialog;
